var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "supplier-after-sales-panel" },
    [
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "toolbar-title" }, [_vm._v("供应商售后信息")]),
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: {
                  size: "mini",
                  icon: "el-icon-refresh",
                  loading: _vm.loading,
                },
                on: { click: _vm.getDetail },
              },
              [_vm._v("刷新")]
            ),
            _c(
              "el-button",
              {
                attrs: {
                  size: "mini",
                  type: "primary",
                  icon: "el-icon-search",
                  loading: _vm.syncLoading,
                },
                on: { click: _vm.handleSyncStatus },
              },
              [_vm._v(" 同步售后状态 ")]
            ),
          ],
          1
        ),
      ]),
      _c("el-alert", {
        staticClass: "mb15",
        attrs: {
          type: "warning",
          closable: false,
          "show-icon": "",
          title: "手动兜底：这里会直接查询开放平台售后状态并回写本地记录。",
        },
      }),
      !_vm.afterSales && !_vm.loading
        ? _c("el-empty", { attrs: { description: "暂无供应商售后信息" } })
        : _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
            },
            [
              _c(
                "el-descriptions",
                { attrs: { column: 2, border: "", size: "small" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "供应商" } }, [
                    _vm._v(
                      _vm._s(_vm.valueOrDash(_vm.afterSales.supplierCode))
                    ),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "本地订单号" } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.valueOrDash(
                            _vm.afterSales.merOrderNo || _vm.orderNo
                          )
                        )
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "供应商订单ID" } },
                    [_vm._v(_vm._s(_vm.valueOrDash(_vm.afterSales.orderId)))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "供应商售后ID" } },
                    [
                      _vm._v(
                        _vm._s(_vm.valueOrDash(_vm.afterSales.afterSaleId))
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "售后状态" } },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            size: "mini",
                            type: _vm.statusTagType(_vm.afterSales.status),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatStatus(_vm.afterSales.status)) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("el-descriptions-item", { attrs: { label: "取消状态" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatCancelStatus(_vm.afterSales.cancelStatus)
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "售后数量" } }, [
                    _vm._v(_vm._s(_vm.valueOrDash(_vm.afterSales.num))),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "退款金额" } }, [
                    _vm._v(_vm._s(_vm.formatMoney(_vm.afterSales.totalRefund))),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "问题类型" } }, [
                    _vm._v(_vm._s(_vm.valueOrDash(_vm.afterSales.problemType))),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "规格ID" } }, [
                    _vm._v(_vm._s(_vm.valueOrDash(_vm.afterSales.attrValueId))),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "申请错误" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.joinError(
                          _vm.afterSales.addErrorCode,
                          _vm.afterSales.addErrorInfo
                        )
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "查询错误" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.joinError(
                          _vm.afterSales.queryErrorCode,
                          _vm.afterSales.queryErrorInfo
                        )
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "回寄物流" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.joinDelivery(
                          _vm.afterSales.backDeliveryName,
                          _vm.afterSales.backDeliveryNo
                        )
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "回寄错误" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.joinError(
                          _vm.afterSales.backErrorCode,
                          _vm.afterSales.backErrorInfo
                        )
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "取消时间" } }, [
                    _vm._v(_vm._s(_vm.valueOrDash(_vm.afterSales.cancelTime))),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "取消错误" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.joinError(
                          _vm.afterSales.cancelErrorCode,
                          _vm.afterSales.cancelErrorInfo
                        )
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "创建时间" } }, [
                    _vm._v(_vm._s(_vm.valueOrDash(_vm.afterSales.createTime))),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "更新时间" } }, [
                    _vm._v(_vm._s(_vm.valueOrDash(_vm.afterSales.updateTime))),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "退货地址", span: 2 } },
                    [
                      _vm._v(
                        _vm._s(_vm.valueOrDash(_vm.afterSales.returnAddress))
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "问题描述", span: 2 } },
                    [
                      _vm._v(
                        _vm._s(_vm.valueOrDash(_vm.afterSales.problemContent))
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "问题图片", span: 2 } },
                    [
                      _vm.imageList.length
                        ? _c(
                            "div",
                            { staticClass: "image-list" },
                            _vm._l(_vm.imageList, function (item, index) {
                              return _c("el-image", {
                                key: index,
                                attrs: {
                                  src: item,
                                  "preview-src-list": _vm.imageList,
                                  fit: "cover",
                                },
                              })
                            }),
                            1
                          )
                        : _c("span", [_vm._v("-")]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }